import { string, number } from "prop-types"
import { Text } from "@planningcenter/tapestry-react"

const Assignment = ({ name, count, assignmentPath }) => {
  return count > 0 ? (
    <Text>
      <a href={assignmentPath}>{name}</a> {` (${count})`}
    </Text>
  ) : null
}

Assignment.propTypes = {
  name: string.isRequired,
  count: number.isRequired,
  assignmentPath: string.isRequired
}

export default Assignment
